import NewsFeed from "./components/NewsFeed";

function App() {
  
  return (
    <div className="rootContainer">
      <NewsFeed />
    </div>
  );
}

export default App;
